import { shallowRef, getCurrentInstance, watch, computed } from "vue";
function useVModelProxy(options) {
  const {
    props,
    propName = "modelValue",
    defaultValue,
    eventName,
    internalRef,
    transform,
    emit
  } = options;
  const internal = internalRef ?? shallowRef(defaultValue ?? props[propName]);
  const vm = getCurrentInstance();
  const _emit = emit || (vm == null ? void 0 : vm.emit);
  const _eventName = eventName || `update:${String(propName)}`;
  if (defaultValue !== void 0 && defaultValue !== null) {
    _emit == null ? void 0 : _emit(_eventName, internal.value);
  }
  watch(
    () => props[propName],
    (newVal) => internal.value = newVal
  );
  return computed({
    get() {
      return internal.value;
    },
    set: (value) => {
      const transformedValue = typeof transform === "function" ? transform(value) : value;
      internal.value = transformedValue;
      _emit == null ? void 0 : _emit(_eventName, transformedValue);
    }
  });
}
export {
  useVModelProxy
};
